export default "__VITE_PUBLIC_ASSET__fc9437bc__"